<div class="dialog-container">
    <h1 class="condensed dialog-title" mat-dialog-title>Inhuur</h1>
    <div class="dialog-content" mat-dialog-content>
        <mat-selection-list (selectionChange)="listChange($event)">
            @for (entityFormGroup of formArray.controls; track entityFormGroup) {
                <mat-list-option
                    [selected]="entityFormGroup.value.count > 0"
                    [value]="entityFormGroup.value.entity_id"
                    [disabled]="data.disabled"
                    color="primary"
                    checkboxPosition="before">
                    <div class="d-flex align-items-center">
                        @if (entitiesMap?.get(entityFormGroup.value.entity_id).name !== 'Asfaltploeg') {
                            <input
                                class="count-input me-2"
                                [formControl]="entityFormGroup.controls.count"
                                (click)="focus($event)"
                                appDecimalInput
                                placeholder="Aantal" />
                        }
                        <div>{{ entitiesMap?.get(entityFormGroup.value.entity_id).name }}</div>
                    </div>
                </mat-list-option>
            }
        </mat-selection-list>
    </div>
    <div class="d-flex flex-wrap" mat-dialog-actions>
        <button (click)="onNoClick()" mat-button>Annuleren</button>
        <div class="spacer"></div>
        <button (click)="select()" mat-raised-button cdkFocusInitial color="primary">Selecteer</button>
    </div>
</div>
